import axiosInstance from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const paidSearchService = { getPaidSearch: (companyId, startDate,endDate) => axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.ENGAGEMENT}/${API_PATH.PAID_SEARCH_SUMMARY_ANALYSIS}/${startDate}/${endDate}`) };

export default paidSearchService;